import { Box, styled } from '@creditas-ui/react'

export const CardHeaderResumeStyle = styled(Box)`
  padding: 15px 0;

  border-bottom: 1px solid ${({ theme }) => theme.colors.neutral[15]};

  display: flex;
  justify-content: space-between;
`
export const MetaHeader = styled(Box)``

export const SlugStep = styled(Box)`
  background: ${({ theme }) => theme.colors.neutral[15]};
  color: ${({ theme }) => theme.colors.neutral[90]};
  border-radius: 16px;
  max-height: 24px;
  padding: 2px 8px;
`
